export default __webpack_public_path__ + "static/media/win.abeb4707.wav";